/**
 * Crypto utilities for pairing tokens, short codes, and hashing.
 * Uses Web Crypto API (SHA-256).
 */

const CHARSET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // no 0/O/1/I

/** Generate a random hex token */
export function generateToken(bytes = 32): string {
  const arr = crypto.getRandomValues(new Uint8Array(bytes));
  return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
}

/** Generate a short alphanumeric code (default 6 chars) */
export function generateShortCode(length = 6): string {
  const arr = crypto.getRandomValues(new Uint8Array(length));
  return Array.from(arr, (b) => CHARSET[b % CHARSET.length]).join("");
}

/** SHA-256 hash → hex string */
export async function sha256Hex(input: string): Promise<string> {
  const data = new TextEncoder().encode(input);
  const hash = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hash), (b) => b.toString(16).padStart(2, "0")).join("");
}
